import "./SectionalGarageDoorRepairSydney.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import GarageServices from "./sections/GarageServices";
import GaragePartners from "./sections/GaragePartners";
import GarageProcess from "./sections/GarageProcess";
import Whyus from "./sections/Whyus";
import GarageComparison from "./sections/GarageComparison";
import GarageTestimonials from "./sections/GarageTestimonials";
import GarageFaq from "./sections/GarageFaq";
import GarageCta from "./sections/GarageCta";
import SectionalCta from "./sections/SectionalCta";
import ServiceAreaExplorer from "./sections/ServiceAreaExplorer";
import Sitefooter from "./sections/Sitefooter";
export default function SectionalGarageDoorRepairSydneyPage() {
  return <div>
      <Header />
      <GarageHero />
      <GarageServices />
      <GaragePartners />
      <GarageProcess />
      <Whyus />
      <GarageComparison />
      <GarageTestimonials />
      <GarageFaq />
      <GarageCta />
      <SectionalCta />
      <ServiceAreaExplorer />
      <Sitefooter />
    </div>;
}